module Elma.Bindings {
    // extends LoadMoreProducts from Tapas

    interface ILoadMoreProducts {
        currentPage: number,
        totalPages: number,
        text: string,
        activeLoader: boolean,
        numberOfJumps?: number
    }

    export class LoadMoreProducts {
        public init(element: any, valueAccessor: () => ILoadMoreProducts, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var load = bindingContext.$root.load();
            var currentValue = ko.unwrap(valueAccessor());
            var currentPage = currentValue.currentPage;
            var totalPages = currentValue.totalPages;
            var showLoader = currentValue.activeLoader;
            var currentJumps = typeof currentValue.numberOfJumps != "undefined" ? currentValue.numberOfJumps : 2;
            var data = new Ftw.Data();
            var currentLoads = currentJumps;
            var currentlyLoading = false;
            $(document).scroll(function () {
                    if (totalPages > currentPage) {
                        var nextPage = currentPage + 1;

                        var loadElement = $(element).offset().top - window.innerHeight;
                        var y = $(document).scrollTop();
                        if (y >= loadElement && currentlyLoading == false) {
                            currentlyLoading = true;
                            if (currentLoads % currentJumps == 0 && showLoader) {
                                // make loads animation show two by two
                                load.active(true);
                                load.text(currentValue.text);
                            }
                            if (showLoader) {
                                currentLoads++;
                            }

                            data.get(window.location.origin + window.location.pathname + (window.location.search ? window.location.search + "&" : "?") + "LayoutTemplate=Designs/Tapas/ajax_page.cshtml&ajaxTapas=true&pagenum=" + nextPage)
                                .then((data) => {
                                    var productsHtml = $(data).children(".productsContainer").html();
                                    $(element).before(productsHtml);
                                    var childBindingContext = bindingContext.createChildContext(viewModel);
                                    ko.applyBindingsToDescendants(childBindingContext, document.getElementById(nextPage.toString()));
                                    currentPage++;

                                    bindingContext.$data.productListLoad(!bindingContext.$data.productListLoad());
                                })
                                .finally(() => {
                                    if (load.active()) {
                                        load.active(false);
                                        load.text("");
                                    }
                                    currentlyLoading = false;

                                });
                        }
                    }
            });

            $(window).unload(function () {
                load.active(false);
            });
        }
    }
    ko.bindingHandlers['loadMoreProducts'] = new LoadMoreProducts();
} 
